/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ResponseApiObject } from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class WeiZhiLieBiaoHuoQu<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags WeiZhiLieBiaoHuoQu
   * @name GetAllCountryUsingGet
   * @summary 获取国家列表
   * @request GET:/dsp-admin/api/location/countryList
   * @secure
   */
  getAllCountryUsingGet = (params: RequestParams = {}) =>
    this.request<ResponseApiObject, void>({
      path: `/dsp-admin/api/location/countryList`,
      method: "GET",
      secure: true,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new WeiZhiLieBiaoHuoQu();
